module.exports = __webpack_public_path__ + "static/media/kyc_zt_mqmb_icon.63eafe8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/kyc_zt_mqmb_icon.png
// module id = 1900
// module chunks = 0 1